module.exports = __webpack_public_path__ + "static/media/map_marker.f9b1ed30.svg";